import { useEffect, useState } from "react";

import { FormControl, InputLabel, OutlinedInput, Select } from "@mui/material";
import { ApiEndpoint } from "@constants/index";
import { useFormContext } from "react-hook-form";
import { useLazyGetIngredientsQuery } from "@modules/ingredient";
import SortableList, { SortableItem } from "react-easy-sort";
import { arrayMoveImmutable } from "array-move";
import { useSortIngredientsMutation } from "@modules/recipe/api/recipe.api";
import { HitText } from "common/Hit/styled";

import { StyledMenuItem, Wrapper } from "./styled";
import { ICreateRecipeFormData } from "@pages/RecipeMutation/helper/types";

const IngredientsList = ({ recipeId }: {recipeId: string}) => {
  const [options, setOptions] = useState<{value: string; label: string; image: string}[]>([]);
  const { watch, setValue } = useFormContext<ICreateRecipeFormData>()
  const [getIngredients] = useLazyGetIngredientsQuery();
  const [ingredientsSorting] = useSortIngredientsMutation()

  const ingredientsListIds = watch('ingredientsListIds')
  const ingredientsList = watch('ingredientsList')

  const handleChange = (event: any) => {
    const { target: { value } } = event;

    setValue('ingredientsListIds', value)
  };

  const getIngredientsData = async () => {
    try {
      const { ingredients } = await getIngredients({ limit: 500, offset: 0 }).unwrap()

      const result = ingredients.map(({ id, name, images }) => ({
        value: id,
        label: name,
        image: images?.find((image) => image.isMain)?.url || images[0]?.url
      }))

      setOptions(result)
    } catch (error) {
      console.log("Error", error);
    }
  }

  useEffect(() => {
    getIngredientsData()
  }, [])

  const onSortEnd = async (oldIndex: number, newIndex: number) => {
    const sorted = arrayMoveImmutable(ingredientsList, oldIndex, newIndex);

    const updatedList = sorted.map((s, i) => ({ ...s, sort: i }))

    setValue('ingredientsList', updatedList)

    const list = updatedList.map((item, index) => {
      return {
        index,
        recipeId,
        id: item.ingredient.id,
      }
    })

    await ingredientsSorting({ list })
  }

  return (
    <Wrapper>
      <FormControl sx={{ margin: '7px 0 7px 0', width: 300 }}>
        <InputLabel id="demo-multiple-name-label">Ingredients</InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          sx={{
            '#demo-multiple-name': {
              display: 'grid',
              gap: '3px',
              gridTemplateColumns: '10fr 10fr 1fr'
            }
          }}
          multiple
          value={ingredientsListIds || []}
          onChange={handleChange}
          input={<OutlinedInput label="Products" />}
        >
          {options.map((option) => (
            <StyledMenuItem
              key={option.value}
              value={option.value}
            >
              <img
                width="40"
                height="40"
                src={`${ApiEndpoint}/${option.image}`}
                alt="Product"
              />
              <p>{option.label}</p>
            </StyledMenuItem>
          ))}
        </Select>
      </FormControl>
      {
        ingredientsList?.length && (
          <HitText>
            If you chouse new ingredient for recipe, first of all save it. After it will be able to sort
          </HitText>
        )
      }
      <div>
        <SortableList
          onSortEnd={onSortEnd}
          lockAxis="x"
          draggedItemClassName="dragged"
        >
          {(ingredientsList ?? [])
            ?.sort((a, b) => a.sort - b.sort)
            ?.map((item) => {
              return (
                <SortableItem key={item.id}>
                  <img
                    width="90"
                    height="90"
                    alt="Product"
                    src={`${ApiEndpoint}/${item.ingredient.images[0].url}`}
                  />
                </SortableItem>
              )
            })}
        </SortableList>
      </div>
    </Wrapper>
  );
}

export default IngredientsList;
